import React from 'react';
import OrderLineItemCard from './OrderLineItemCard';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MessageOutlined } from '@ant-design/icons';

export default function OrderLineItemsList({ order, className }) {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'Components:AlertScreens:Shared:OrderLineItem:OrderLineItemsList',
  });

  return (
    <div className={classnames('space-y-sm', className)}>
      <h6 className="text-base">{t('title')}:</h6>
      {order.line_items.map((item) => (
        <OrderLineItemCard data={item} key={`line-item-${item.id}`} />
      ))}
      {Boolean(order.customer_note) && (
        <p className="flex gap-xs break-words">
          <MessageOutlined className="mt-[3px] shrink-0" />
          <span>
            <span className="font-semibold">{t('order_note')}:</span> {order.customer_note}
          </span>
        </p>
      )}
    </div>
  );
}
